import React from "react";
import { useNavigate } from "react-router";
import useTitanApp from "../../../hooks/useTitanApp";
import TitanLightSVG from "../../../assets/images/Titanverse_Logo_White.svg";
import TitanDarkSVG from "../../../assets/images/Titanverse_Logo_Black.svg";
import TitanNewSVG from "../../../assets/images/NewTitanverseLogo.svg";

export default function PharmacyServicesLogo() {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};
  const navigate = useNavigate();

  const handleLogoClick = () => {
    localStorage.removeItem("hasSetGlobalTabText");
    navigate("/");
  };

  return (
    <div className="logo-wrapper" onClick={handleLogoClick}>
      <TitanNewSVG className="titan-logo" />
    </div>
  );
}

